<template>
    <div class="con">
        <van-notice-bar
                left-icon="volume-o"
                text="2026年湖北省世达实用外国语学校招生工作已全面开始，目前有意向的同学可以联系我们预约参观学校，在线报名。报名成功的学生，我校可确保录取！有任何问题都可以随时联系我们沟通咨询！"
        />

        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/1.jpg" class="autoImg"></div>
        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/2.jpg" class="autoImg"></div>

        <div><a target="_blank" href="//cdn.sjxgty.com/2023/shida/video.mp4"><img src="//cdn.sjxgty.com/page/shida/fm.jpg" class="autoImg"></a></div>
        <Bm>
            <template v-slot:default>
                <van-notice-bar left-icon="volume-o" :scrollable="false">
                    <swipe-item></swipe-item>
                </van-notice-bar>
            </template>
        </Bm>
        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/4.jpg" class="autoImg"></div>

        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/5.jpg" class="autoImg"></div>

        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/6.jpg" class="autoImg"></div>

        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/7.jpg" class="autoImg"></div>
        <Bm>
            <template v-slot:default>
                <van-notice-bar left-icon="volume-o" :scrollable="false">
                    <swipe-item></swipe-item>
                </van-notice-bar>
            </template>
        </Bm>
        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/8.jpg" class="autoImg"></div>
        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/9.jpg" class="autoImg"></div>
        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/10.jpg" class="autoImg"></div>
        <Bm>
            <template v-slot:default>
                <van-notice-bar left-icon="volume-o" :scrollable="false">
                    <swipe-item></swipe-item>
                </van-notice-bar>
            </template>
        </Bm>
        <div @click="open"><img src="//cdn.sjxgty.com/page/shida/11.jpg" class="autoImg"></div>





    </div>
    <BottomComponent></BottomComponent>
    <Msg></Msg>
</template>


<script>
import Msg from "@/components/Msg.vue";
import Bm from '@/components/Bm'
import BottomComponent from "@/components/BottomComponent.vue";
import SwipeItem from "@/components/SwipeItem.vue";
import open53 from "@/api/seviceBtn"
export default {
    name: 'Index',
    components: {SwipeItem, BottomComponent, Bm,Msg},

    setup() {
        function open() {
            open53()
        }

        return {
            open
        }

    }
}
</script>


<style>
.van-notice-bar {
    border-radius: var(--bs-border-radius);
    background: #eee !important;
}

.notice-swipe {
    height: 40px;
    line-height: 40px;
}

.video video {
    width: 100%
}

.con {
    padding-bottom: 50px;
}

@media (min-width: 750px) {
    .con {
        width: 750px;
        margin: 0 auto;
    }
}

@media (max-width: 750px) {
    .con {
        width: 100%;
        margin: 0 auto;
    }
}

.autoImg {
    width: 100%;
}
</style>